module.exports = __webpack_public_path__ + "img/LOGO@3x.01c09060.png";